import { useQuery } from "react-query";
import {
  GetDataByTermsRequest,
  GetPatientTreatmentRecordsResponse,
  PatientTreatmentRecords,
} from "types";
import { get } from "lib/axios";
import { useQueryClient } from "react-query";
import { useEffect } from "react";
import { formatDateToString } from "utils";

const getPatientTreatmentRecords = async (
  patientId: string,
  params: GetDataByTermsRequest
): Promise<PatientTreatmentRecords> => {
  const { data } = await get<GetPatientTreatmentRecordsResponse>(
    `/patients/${patientId}/treatment_records`,
    {
      params: {
        from_date: formatDateToString(params.from_date),
        to_date: formatDateToString(params.to_date),
      },
    }
  );

  return data.map((d) => ({
    treatmentType: d.treatment_type,
    lastTreatmentDate: new Date(Date.parse(d.last_treatment_date)),
  }));
};

export const usePatientTreatmentRecordsQuery = (
  patientId: string,
  params: GetDataByTermsRequest
) => {
  return useQuery(
    [`patientTreatmentRecords`],
    () => {
      return getPatientTreatmentRecords(patientId, params);
    },
    {
      retry: false,
      staleTime: 1000 * 60 * 5,
    }
  );
};

export const useRemoveCacheOnUnMount = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      queryClient.removeQueries("patientTreatmentRecords");
    };
  }, [queryClient]);
};
